import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, useParams, Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Grid, Typography, Avatar, Button, Modal } from "@mui/material";
import { Box } from "@mui/system";
import {
  approvalStatusAction,
  adoptionRequestForApproval,
} from "../../redux/action-creators/adoptionAction";
import LeftSidebar from "../../components/sidebars/LeftSidebar";
import { RoutingLinks } from "../../utils/constants";
import { UserCommonStyles } from "../../styles/CommonStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { capitalize } from "../../utils/helper";
import minImage from "../../images/minImage.png";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  outline: "none !important",
  boxShadow: 24,
  p: 4,
};

const AdoptionRequest = (props: RouteComponentProps) => {
  const { t: translation } = useTranslation();
  const commonStyle = UserCommonStyles();
  const dispatch = useDispatch();
  const { id }: { id: string } = useParams();

  const [adoptionRequestList, setAdoptionRequestList] = useState<any>([]);
  const [loader, setloader] = useState<boolean>(true);
  const [query, setQuery] = useState<string>("");
  const [approvalStatusLoader, setApprovalStatusLoader] =
    useState<boolean>(false);
  const [modal, setModal] = useState({
    show: false,
    name: "",
    isAlreadyApproved: false,
    status: "",
  });

  const getAdoptionRequestList = async () => {
    setloader(true);
    const response: any = await dispatch(
      adoptionRequestForApproval(String(id))
    );
    if (response?.statusCode === 201) {
      setAdoptionRequestList(response?.data);
    } else {
      setAdoptionRequestList([]);
    }
    setloader(false);
  };

  useEffect(() => {
    getAdoptionRequestList();
  }, []);

  const approvalStatusHandler = async (
    id: number,
    post_id: number,
    status: string,
    user_name: string
  ) => {
    setApprovalStatusLoader(true);
    let approvedUser = {
      approved: false,
      activeUser: "",
    };
    if (status === "approved") {
      adoptionRequestList.forEach((ele: any) => {
        if (ele?.adopter_adoption_status === "approved") {
          approvedUser.activeUser = `${capitalize(
            `${ele?.adopter_first_name} ${ele?.adopter_last_name}`
          )}`;
          approvedUser.approved = true;
          // return;
        }
      });
    }
    if (status === "approved" && approvedUser.approved) {
      setApprovalStatusLoader(false);
      return setModal({
        show: true,
        name: approvedUser?.activeUser,
        isAlreadyApproved: true,
        status: "",
      });
    } else {
      const data = {
        id: id,
        adoption_id: post_id,
        status: status,
      };

      const statusResponse: any = await dispatch(approvalStatusAction(data));
      if (statusResponse?.statusCode === 201 && statusResponse?.isRegistered) {
        setModal({
          show: true,
          name: user_name,
          isAlreadyApproved: false,
          status: status,
        });
        getAdoptionRequestList();
      }
      setApprovalStatusLoader(false);
    }
  };

  return (
    <Box>
      <Box className={`${commonStyle.windowColor}`}>
        <Grid container>
          <Grid item md={3}>
            <LeftSidebar />
          </Grid>

          <Grid item md={9}>
            <Box className={commonStyle.p20}>
              <Box
                className={`
                    ${commonStyle.flexCenter} 
                    ${commonStyle.justifySpaceBetween} 
                    ${commonStyle.alignItemsCenter} 
                    ${commonStyle.mb15} 
                    ${commonStyle.mt20}
                `}
              >
                <Typography
                  variant="h6"
                  style={{ marginBottom: "0px !important" }}
                  className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}
                >
                  {"Adoption Request"}
                </Typography>
              </Box>

              <Box className={`${commonStyle.p20} ${commonStyle.card}`}>
                <Box>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#01B4BC" }}>
                        <TableRow>
                          <TableCell
                            align="left"
                            className={commonStyle.tableColumntext}
                          >
                            Name
                          </TableCell>
                          <TableCell
                            align="center"
                            className={commonStyle.tableColumntext}
                          >
                            Status
                          </TableCell>
                          <TableCell
                            align="center"
                            className={commonStyle.tableColumntext}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {adoptionRequestList.length > 0 ? (
                          // adoptionRequestList.filter((ele: any) => {
                          //   if (query === ("" || null || undefined)) {
                          //     return ele;
                          //   } else if (ele.name.toLowerCase().includes(query.toLowerCase())) {
                          //     return ele;
                          //   } else {
                          //     return false;
                          //   }
                          // })
                          adoptionRequestList?.map(
                            (row: any, index: number) => {
                              return (
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell align="center">
                                    <Link
                                      to={{
                                        pathname: `${RoutingLinks.profiles}${row?.adopter_id}`,
                                      }}
                                      className={`${commonStyle.anchorDecoration}`}
                                    >
                                      <Box
                                        className={`${commonStyle.py15} ${commonStyle.wallUserInfo}`}
                                      >
                                        <Avatar
                                          alt={translation("story_person")}
                                          src={
                                            row?.adopter_profile
                                              ? row?.adopter_profile
                                              : minImage
                                          }
                                        />
                                        <Box className={commonStyle.ml10}>
                                          <Typography
                                            variant="h2"
                                            className={commonStyle.black}
                                          >
                                            {row?.adopter_first_name
                                              ? capitalize(
                                                  `${row?.adopter_first_name} ${row?.adopter_last_name}`
                                                )
                                              : ""}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Link>
                                  </TableCell>

                                  <TableCell align="center">
                                    <Box
                                      sx={{
                                        minWidth: 110,
                                        height: 40,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          width: 90,
                                          height: 30,
                                          borderRadius: 13.5,
                                          backgroundColor:
                                            row?.adopter_adoption_status ==
                                            "approved"
                                              ? "rgba(0, 190, 53, 0.1)"
                                              : row?.adopter_adoption_status ==
                                                "cancelled"
                                              ? "#ffcccc"
                                              : "rgba(250, 255, 0, 0.2)",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            fontSize: "16px",
                                            fontWeight: "400",
                                            color:
                                              row?.adopter_adoption_status ==
                                              "approved"
                                                ? "#00BE35"
                                                : row?.adopter_adoption_status ==
                                                  "cancelled"
                                                ? "#D95557"
                                                : "#DDD400",
                                          }}
                                        >
                                          {row?.adopter_adoption_status
                                            ? capitalize(
                                                row?.adopter_adoption_status
                                              )
                                            : ""}
                                        </p>
                                      </Box>
                                    </Box>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Box
                                      sx={{ gap: "10px" }}
                                      className={`${commonStyle.dflex} ${commonStyle.alignItemsCenter} ${commonStyle.justifyCenter}`}
                                    >
                                      <Box
                                        className={`${commonStyle.orangeBtn} ${commonStyle.mt10}`}
                                      >
                                        <Button
                                          className={`${commonStyle.font16} ${commonStyle.fontWeight400}`}
                                          disabled={
                                            row?.adopter_adoption_status ===
                                              "approved" || approvalStatusLoader
                                          }
                                          onClick={() =>
                                            approvalStatusHandler(
                                              row?.id,
                                              row?.adoption_id,
                                              "approved",
                                              capitalize(
                                                `${row?.adopter_first_name} ${row?.adopter_last_name}`
                                              )
                                            )
                                          }
                                        >
                                          {"Approve"}
                                        </Button>
                                      </Box>
                                      <Box
                                        className={`${commonStyle.orangeOutlineBtn} ${commonStyle.mt10}`}
                                      >
                                        <Button
                                          className={`${commonStyle.font16} ${commonStyle.fontWeight400}`}
                                          disabled={
                                            row?.adopter_adoption_status ===
                                              "cancelled" ||
                                            approvalStatusLoader
                                          }
                                          onClick={() =>
                                            approvalStatusHandler(
                                              row?.id,
                                              row?.adoption_id,
                                              "cancelled",
                                              capitalize(
                                                `${row?.adopter_first_name} ${row?.adopter_last_name}`
                                              )
                                            )
                                          }
                                        >
                                          {"Cancel"}
                                        </Button>
                                      </Box>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )
                        ) : loader ? (
                          <Typography
                            mt={2}
                            mb={2}
                            ml={2}
                            className={`${commonStyle.bold2}`}
                          >
                            {translation("loading")}
                          </Typography>
                        ) : (
                          <Typography
                            mt={2}
                            mb={2}
                            ml={2}
                            className={`${commonStyle.bold2}`}
                          >
                            {translation("missing_record")}
                          </Typography>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Modal
        open={modal.show}
        onClose={() =>
          setModal({
            show: false,
            name: "",
            isAlreadyApproved: false,
            status: "",
          })
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* {modal?.status === "approved" ? (
            <Typography
              id="modal-modal-title"
              variant="h5"
              className={`${commonStyle.textCenter} ${commonStyle.bold1} ${commonStyle.mt20}`}
            >
              {translation("Congratulations")}
            </Typography>
          ) : null} */}

          <Box className={commonStyle.py15}>
            <Box className={`${commonStyle.textCenter}`}>
              <Typography>
                {`${modal?.name ? modal?.name : "User"} ${
                  modal?.isAlreadyApproved && modal?.status === ""
                    ? "has already been approved, please cancel first."
                    : `has been ${
                        modal?.status === "approved" ? " approved" : "cancelled"
                      } for adoption.`
                }`}
              </Typography>
            </Box>

            <Box
              className={`${commonStyle.blueBtn} ${commonStyle.py15} ${commonStyle.textCenter} ${commonStyle.mt10}`}
            >
              <Button
                className={`${commonStyle.btnpy1060}`}
                onClick={() =>
                  setModal({
                    show: false,
                    name: "",
                    isAlreadyApproved: false,
                    status: "",
                  })
                }
              >
               {"Ok"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdoptionRequest;
